interface IUpdateEventNameBasedOnBillingInterval {
  eventName?:
    | "voip_starting_out"
    | "voip_flying_high"
    | "user_purchase_starting_out"
    | "user_purchase_flying_high"
    | "voip_enterprise"
    | "user_purchase_enterprise";
  billing_interval?: string;
}

export const updateEventNameBasedOnBillingInterval = ({
  eventName,
  billing_interval,
}: IUpdateEventNameBasedOnBillingInterval) => {
  if (billing_interval === "yearly") {
    return `${eventName}_yearly`;
  }
  return `${eventName}_monthly`;
};
